import { FAQDefault } from './FAQDefault';
import { LogoLayoutNavbar } from './../Home/components/LogoLayoutNavbar';

FAQDefault.Navbar = LogoLayoutNavbar;

export default FAQDefault;
